module.exports = __webpack_public_path__ + "static/img/introduce-img1.0b599639.png";